import uuidv1 from 'uuid/v1';

// HEAD DATA
export const headData = {
  title: 'Karthik V | Web Developer', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: 'Welcome to My Portofolio ', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hi, My name is',
  name: 'Karthik V',
  subtitle: "I'm a MERN Stack Web Developer & Flutter Mobile App Developer",
  cta: 'Know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'p1.jpeg',
  paragraphOne:
    'I am a Web Developer with enthusiasm and focused on Full Stack Web Development and Mobile App Development.',
  paragraphTwo:
    'I am passionate about building scalable software, creating effective solutions, and learning every day to grow professionally in the IT field.',
  paragraphThree: 'Feel free to contact me via email at any time',
  resume: 'https://pdfhost.io/v/0z.UcTnYG_My_Resume.pdf',
  // edit: https://pdfhost.io/edit?doc=6a76fbfb-5c34-43b7-be5b-aab0599aae82
  // share: https://pdfhost.io/v/0z.UcTnYG_My_Resume.pdf
  // prev : https://pdfhost.io/v/CHUxfqZVm_Karthik_V_Resumepdf.pdf
};

// PROJECTS DATA
export const projectsData = [
  {
    id: uuidv1(),
    img: 'project-SB.png',
    title: 'Smart-Brain Face Detection Web App',
    info:
      "A full-stack web application using the (MERN) Stack, this app allows you to identify the detection of faces in any image supplied. This was achieved thanks to Clarifai's artificial intelligence API.",
    info2:
      'I used React, Node, Express.js and MongoDB in order to create this web application and hosted the front-end using github pages and back-end server with Heroku.',
    url: 'https://v-karthik-221199.github.io/Smart-Brain-Web-app/',
    repo: 'https://github.com/V-Karthik-221199/Smart-Brain-Web-app', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project-cov.png',
    title: 'COVID-19 Stats Tracker',
    info:
      'A real-time COVID-19 Statistics tracker that visualizes the current situation of the pandemic all over the world',
    info2: 'I used React, React Hooks, Material UI, Chart.js in order to create this web app',
    url: 'https://v-karthik-221199.github.io/Covid-19-Stats-Tracker/',
    repo: 'https://github.com/V-Karthik-221199/Covid-19-Stats-Tracker', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project-ecom.png',
    title: 'Mobile E-commerce Website',
    info:
      'A fully functioning E-commerce website for Mobile Phones with PayPal Payment Gateway implemented with PayPal sandbox',
    info2:
      'I used React, React-Router, React Context API, PayPal Checkout API using Sandbox in order to create this website.',
    url: 'https://e-comm-web-vk.netlify.app/',
    repo: 'https://github.com/V-Karthik-221199/E-commerce-website', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: "Let's build together!",
  email: 'vkarthik221199@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: uuidv1(),
      name: 'twitter',
      url: 'https://www.linkedin.com/in/vkarthik221199',
    },

    {
      id: uuidv1(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/vkarthik221199',
    },
    {
      id: uuidv1(),
      name: 'github',
      url: 'https://github.com/V-Karthik-221199',
    },
    {
      id: uuidv1(),
      name: 'facebook',
      url: 'https://github.com/V-Karthik-221199',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
